import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import Dashboard from "../pages/Dashboard.vue"
import Users from "../pages/Users.vue"
import UserForm from "../pages/UserForm.vue"
import UserSeats from "../pages/UserSeats.vue"
import Cards from "@/pages/Cards.vue";
import CardView from "../pages/CardView.vue"
import VisiteMediche from "../pages/VisiteMediche.vue"
import Settings from "@/pages/Settings.vue";
import Reports from "../pages/Reports.vue"
import ReportView from "../pages/ReportView.vue"
import Kits from "@/pages/Kits.vue";
import KitForm from "@/pages/KitForm.vue";
import Products from "@/pages/Products.vue";
import ProductForm from "@/pages/ProductForm.vue";
import Lessons from "@/pages/Lessons.vue";
import LessonForm from "@/pages/LessonForm.vue";
import Genres from "@/pages/Genres.vue";
import GenreForm from "@/pages/GenreForm.vue";
import Difficulties from "@/pages/Difficulties.vue";
import DifficultyForm from "@/pages/DifficultyForm.vue";
import Subcategories from "../pages/Subcategories.vue"
import SubcategoryForm from "../pages/SubcategoryForm.vue"
import Categories from "../pages/Categories.vue"
import CategoryForm from "../pages/CategoryForm.vue"
import CmsList from "../pages/CmsList.vue"
import CmsForm from "../pages/CmsForm.vue"
import Banners from "@/pages/Banners.vue";
import BannerForm from "@/pages/BannerForm.vue"
import GalleryList from "../pages/GalleryList.vue"
import GalleryForm from "../pages/GalleryForm.vue"
import Medias from "@/pages/Medias.vue";
import MediaForm from "@/pages/MediaForm.vue";
import Exercises from "@/pages/Exercises.vue"
import ExerciseForm from "@/pages/ExerciseForm.vue"
import Purchases from "@/pages/Purchases.vue";
import PurchaseView from "../pages/PurchaseView.vue"
import PurchaseForm from "../pages/PurchaseForm.vue"
import PurchaseWizard from "../pages/PurchaseWizard.vue"
import HomeSections from "@/pages/HomeSections.vue";
import HomeSectionForm from "@/pages/HomeSectionForm.vue";
import Calendar from "../pages/Calendar.vue"
import TopGymExperience from "@/pages/TopGymExperience.vue";
import SalaCorsi from "../pages/SalaCorsi.vue"
import OpenGym from "../pages/OpenGym.vue"
import Gym from "../pages/Gym.vue"
import Vacu from "../pages/Vacu.vue"
import BookingPrefs from "@/pages/BookingPrefs.vue";
import BookingPrefForm from "../pages/BookingPrefForm.vue"
import Medical from "../pages/Medical.vue"
import Logs from "@/pages/Logs.vue";
import Stats from "@/pages/Stats.vue";
/*




*/
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard
    },
    {
        path: '/users',
        name: 'users',
        component: Users
    },
    {
        path: '/users/:id',
        name: 'user form',
        component: UserForm
    },
    {
        path: '/users/:id/seats',
        name: 'user seats',
        component: UserSeats
    },
    {
        path: '/cards',
        name: 'cards',
        component: Cards
    },
    {
        path: '/cards/:id',
        name: 'card view',
        component: CardView
    },
    {
        path: '/mediche',
        name: 'visitemediche',
        component: VisiteMediche
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings
    },
    {
        path: '/reports',
        name: 'reports',
        component: Reports
    },
    {
        path: '/reports/:id',
        name: 'report view',
        component: ReportView
    },
    {
        path: '/kits',
        name: 'kits',
        component: Kits
    },
    {
        path: '/kits/:id',
        name: 'kit form',
        component: KitForm
    },
    {
        path: '/kits/:id/products',
        name: 'kit products',
        component: Products
    },
    {
        path: '/kits/:kitId/products/:id',
        name: 'product form',
        component: ProductForm
    },
    {
        path: '/kits/:kitId/products/:id/lessons',
        name: 'product lessons',
        component: Lessons
    },
    {
        path: '/kits/:kitId/products/:productId/lessons/:id',
        name: 'lesson form',
        component: LessonForm
    },
    {
        path: '/genre',
        name: 'genre',
        component: Genres
    },
    {
        path: '/genre/:id',
        name: 'genre form',
        component: GenreForm
    },
    {
        path: '/difficulties',
        name: 'difficulties',
        component: Difficulties
    },
    {
        path: '/difficulties/:id',
        name: 'difficulty form',
        component: DifficultyForm
    },
    {
        path: '/subcategories',
        name: 'subcategories',
        component: Subcategories,
    },
    {
        path: '/subcategories/:id',
        name: 'subcategory form',
        component: SubcategoryForm
    },
    {
        path: '/categories',
        name: 'categories',
        component: Categories
    },
    {
        path: '/categories/:id',
        name: 'category form',
        component: CategoryForm
    },
    {
        path: '/cms',
        name: 'cms',
        component: CmsList
    },
    {
        path: '/cms/:id',
        name: 'cms form',
        component: CmsForm
    },
    {
        path: '/banners',
        name: 'banners',
        component: Banners
    },
    {
        path: '/banners/:id',
        name: 'banner form',
        component: BannerForm
    },{
        path: '/gallery',
        name: 'gallery',
        component: GalleryList
    },
    {
        path: '/gallery/:id',
        name: 'gallery form',
        component: GalleryForm
    },
    {
        path: '/media',
        name: 'media',
        component: Medias
    },
    {
        path: '/media/:id',
        name: 'media form',
        component: MediaForm
    },

    {
        path: '/exercises',
        name: 'exercises',
        component: Exercises
    },
    {
        path: '/exercises/:id',
        name: 'exercise form',
        component: ExerciseForm
    },
    {
        path: '/sells',
        name: 'sells',
        component: Purchases
    },
    {
        path: '/sells/:id',
        name: 'sell form',
        component: PurchaseForm
    },
    {
        path: '/sells/:id/view',
        name: 'sell view',
        component: PurchaseView
    },
    {
        path: '/wizard',
        name: 'wizard',
        component: PurchaseWizard
    },
    {
        path: '/home',
        name: 'home',
        component: HomeSections
    },
    {
        path: '/home/:id',
        name: 'home form',
        component: HomeSectionForm
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: Calendar
    },
    {
        path: '/topgymexperience',
        name: 'topgymexperience',
        component: TopGymExperience
    },
    {
        path: '/salacorsi',
        name: 'salacorsi',
        component: SalaCorsi
    },
    {
        path: '/opengym',
        name: 'opengym',
        component: OpenGym
    },
    {
        path: '/gym',
        name: 'gym',
        component: Gym
    },
    {
        path: '/vacu',
        name: 'vacu',
        component: Vacu
    },
    {
        path: '/bookingprefs',
        name: 'bookingprefs',
        component: BookingPrefs
    },
    {
        path: '/bookingprefs/:id',
        name: 'bookingpref form',
        component: BookingPrefForm
    },
    {
        path: '/medical',
        name: 'medical',
        component: Medical
    },
    {
        path: '/logs',
        name: 'logs',
        component: Logs
    },
    {
        path: '/stats',
        name: 'stats',
        component: Stats
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router